export const BUYING_FOR_OWN_NAME = 'buyingOwnName';
export const BUYING_FOR_OWN_NAME_PLUS_BUYERS = 'buyingOwnNamePlusBuyers';
export const BUYING_FOR_SOMEONE_ELSE = 'buyingSomeoneElse';



// WEBPACK FOOTER //
// ./app/components/register-to-bid/js/buying-for-options.js